const planLimits = {
    free: {
        organizations: 1,
        divisions: 1,
        seasons: 1,
        marketplaceListings: 3,
    },
    pro: {
        organizations: 1,
        divisions: 5,
        seasons: Infinity,
        marketplaceListings: 10,
    },
    elite: {
        organizations: 3,
        divisions: Infinity,
        seasons: Infinity,
        marketplaceListings: Infinity,
    },
    enterprise: {
        organizations: 5,
        divisions: Infinity,
        seasons: Infinity,
        marketplaceListings: Infinity,
    },
    trial: {
        organizations: 1,
        divisions: 1,
        seasons: 1,
        marketplaceListings: 3,
    }
};

export function getPlanLimit(planName, item) {
    return planLimits[planName]?.[item] ?? 0;
}
